module.exports = "https://cdn.test.betha.cloud/base/g4/design/4.0.3/assets/images/right-click.svg";